<template>
    <modal-centered-base
	v-if="getDeviceInUse !== 'ios'"
    :title="datePickerTitle"
    :leftButtonText="t('datePicker.cancel')"
    :rightButtonText="t('datePicker.apply')"
    @hideMe="emit('hideMe')"
    @clicked="emit('hideMe')"
    @rightButtonClicked="emit('dateUpdate', date)">
        <date-picker-mobile
        :disabledDates="disabledDates"
        :selectedDate="selectedDate"
        @dateUpdate="date = $event"/>
    </modal-centered-base>
</template>

<script setup>
import ModalCenteredBase from '@/components/generic/modals/centered/Base'
import DatePickerMobile from '@/components/generic/datepicker/AndroidPicker'
import moment from '@/assets/setups/moment'

/* Vue */
import { onMounted } from 'vue'

/* Store */
import { mapGetters } from '@/store/helpers/mappers'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/* Emmitters */
const emit = defineEmits(['hideMe', 'rightButtonClicked', 'dateUpdate'])

/* mapActions & mapGetters */
const { getDeviceInUse } = mapGetters()

const props = defineProps({
    selectedDate: Date,
    disabledDates: Object,
	datePickerTitle: String
})

onMounted(() => {
	if (getDeviceInUse.value === 'ios') {
		window.datePicker.show({
			mode: 'date',
			date: props.selectedDate || new Date(),
			minDate: props.disabledDates.to || '',
			maxDate: props.disabledDates.from || '',
			doneButtonLabel: t('datePicker.apply'),
			doneButtonColor: '#00a3e0',
			cancelButtonLabel: t('datePicker.cancel'),
			cancelButtonColor: '#00a3e0',
			title: props.datePickerTitle,
			titleColor: '#00325a',
			locale: `${moment.locale()}_${moment.locale().toUpperCase()}`
		}, (date) => {
			if (date) emit('dateUpdate', date)
			emit('hideMe')
		})
	}
})
</script>

<style lang="scss" scoped>
.date-picker-wrapper {
    :deep(.day-wrapper), :deep(.month-wrapper), :deep(.year-wrapper) {
        div {
            color: var(--primary-variant-3);
        }
    }

    :deep(.top-line) {
        background-color: var(--primary-variant-3);
    }

    :deep(.bottom-line) {
        background-color: var(--primary-variant-3);
    }
}
</style>
